import { useMemo, useState } from "react";

export const useCorporateSlice = () => {
  const [selectedCorporates, setSelectedCorporates] = useState([]);
  const selectedCorporate = useMemo(() => (selectedCorporates.length === 1 ? selectedCorporates[0] : null), [selectedCorporates]);
  const selectedCorporateId = useMemo(() => (selectedCorporate ? selectedCorporate.id : null), [selectedCorporate]);

  return useMemo(() => ({ selectedCorporates, setSelectedCorporates, selectedCorporate, selectedCorporateId }), [selectedCorporates, selectedCorporate, selectedCorporateId]);
};
